document.addEventListener("DOMContentLoaded", function () {
  const mtoButtons = document.querySelectorAll("[data-made-to-order-button]");

  // Helper function to get "Sold Out" text from theme strings
  function getSoldOutText() {
    if (typeof theme !== 'undefined' && theme.strings && theme.strings.soldOut) {
      return theme.strings.soldOut;
    }
    if (typeof window.theme !== 'undefined' && window.theme.strings && window.theme.strings.soldOut) {
      return window.theme.strings.soldOut;
    }
    return 'sold-out';
  }

  // Helper function to update dispatch text based on variant availability
  function updateDispatchText(button, isAvailable) {
    const dispatchElement = button.closest('.made-to-order-button')?.querySelector('[data-second-product-dispatch]');
    if (!dispatchElement) {
      return;
    }

    const originalDispatchText = dispatchElement.dataset.mtoDispatchText || '';
    
    if (isAvailable) {
      // Restore original dispatch text when variant is available
      dispatchElement.textContent = originalDispatchText;
    } else {
      // Show "Sold Out" when variant is unavailable (matching theme.js pattern)
      const soldOutText = getSoldOutText();
      dispatchElement.textContent = soldOutText.charAt(0).toUpperCase() + soldOutText.slice(1);
    }
  }

  // Initialize each MTO button
  mtoButtons.forEach(async (button) => {
    try {
      // Check if KTO is disabled for this product
      const productKto = button.dataset.productKto;
      if (productKto === "false" || productKto === false) {
        button.disabled = true;
        const dispatchElement = button.closest('.made-to-order-button')?.querySelector('[data-second-product-dispatch]');
        if (dispatchElement) {
          const unavailableText = button.dataset.productKtoUnavailableText || "Knitted-to-order not available.";
          dispatchElement.textContent = unavailableText;
        }
        return;
      }

      // Get the MTO product data immediately
      const handle = button.dataset.mtoProductId;
      
      const response = await fetch(`/products/${handle}.js`);
      const secondProduct = await response.json();

      // Get the original product's current variant options
      const variantOptions = JSON.parse(button.dataset.variantOptions || "[]");

      // For simplicity, assume size is the last option (check if we have any options)
      if (variantOptions.length > 0) {
        const sizeOption = variantOptions[variantOptions.length - 1];
        
        // Find matching variant with the same size
        let matchingVariant = secondProduct.variants.find(
          (variant) => variant.options[variantOptions.length - 1] === sizeOption
        );
        
        if (matchingVariant) {
          button.dataset.mtoVariantId = matchingVariant.id;
          const isAvailable = matchingVariant.available;

          // Always update button state
          button.disabled = !isAvailable;

          // Update button text with translations from data attributes
          const textSpan = button.querySelector(".btn__text");
          if (textSpan) {
            if (isAvailable) {
              const mtoText = button.dataset.textAddToCart || "Add Made-to-Order";
              // Extract base text if it contains price (split by ·)
              const baseText = mtoText.split(" · ")[0];
              // Format price using Shopify's money format
              const formattedPrice = window.theme && window.theme.formatMoney 
                ? window.theme.formatMoney(matchingVariant.price, window.theme.moneyFormat || "${{amount}}")
                : `$${(matchingVariant.price / 100).toFixed(2)}`;
              const translatedText = baseText.concat(" · ", formattedPrice);
              textSpan.textContent = translatedText;
            } else {
              const soldOutText = button.dataset.textSoldOut || "Sold Out";
              textSpan.textContent = soldOutText;
            }
          }

          // Update dispatch text based on variant availability (initial state)
          updateDispatchText(button, isAvailable);
        } else {
          // No matching variant found
          button.disabled = true;
          const textSpan = button.querySelector(".btn__text");
          if (textSpan) {
            textSpan.textContent = button.dataset.textSoldOut || "Sold Out";
          }

          // Update dispatch text to show "Sold Out" when no matching variant (initial state)
          updateDispatchText(button, false);
        }
      }

      // Remove any existing click handler to prevent duplicates
      button.removeEventListener("click", handleButtonClick);
      
      // Add click handler
      button.addEventListener("click", handleButtonClick);
    } catch (error) {
      // Set to disabled on error
      button.disabled = true;
    }
  });

  // Handle button click
  async function handleButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget;

    if (button.classList.contains("loading") || button.disabled) {
      return;
    }

    try {
      button.classList.add("loading");
      button.disabled = true;

      const selectedVariantId = button.dataset.mtoVariantId;
      
      if (!selectedVariantId) {
        throw new Error("No matching variant available");
      }

      const formData = new FormData();
      formData.append("id", selectedVariantId);
      formData.append("quantity", 1);

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        formData.append("sections", "api-cart-items");
        formData.append("sections_url", window.location.pathname);
      }

      const cartResponse = await fetch(`/cart/add.js`, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });

      const cartData = await cartResponse.json();
      
      if (cartData.status) {
        throw new Error(cartData.description || "Error adding to cart");
      }

      document.dispatchEvent(
        new CustomEvent("theme:cart:refresh", { bubbles: true })
      );

      if (cartDrawer) {
        cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
      } else {
        window.location = "/cart";
        return;
      }

      button.classList.remove("loading");
      button.classList.add("is-added");

      setTimeout(() => {
        button.classList.remove("is-added");
        button.disabled = false;
      }, 1000);
    } catch (error) {
      button.classList.remove("loading");
      button.disabled = false;
    }
  }

  // Listen for variant changes on product sections
  document.addEventListener("theme:variant:change", function (event) {
    const variant = event.detail.variant;
    
    if (!variant || !variant.options) {
      return;
    }

    // Find the product section container
    // The event bubbles from the product section, so find it by traversing up from event.target
    const productSection = event.target.closest && event.target.closest('[data-section-type="product"]') 
                          || document.querySelector('[data-section-type="product"]');
    
    if (!productSection) {
      return;
    }

    // Find all MTO buttons within this product section
    const mtoButtons = productSection.querySelectorAll("[data-made-to-order-button]");
    
    if (mtoButtons.length === 0) {
      return;
    }
    
    // Update all MTO buttons in this product section
    mtoButtons.forEach((button) => {
      updateMtoButtonForVariant(button, variant.options);
    });
  });

  // Update MTO button when variant changes
  async function updateMtoButtonForVariant(button, variantOptions) {
    try {
      // Check if KTO is disabled for this product
      const productKto = button.dataset.productKto;
      if (productKto === "false" || productKto === false) {
        button.disabled = true;
        const dispatchElement = button.closest('.made-to-order-button')?.querySelector('[data-second-product-dispatch]');
        if (dispatchElement) {
          const unavailableText = button.dataset.productKtoUnavailableText || "Knitted-to-order not available.";
          dispatchElement.textContent = unavailableText;
        }
        return;
      }

      button.dataset.variantOptions = JSON.stringify(variantOptions);

      // Get the product data
      const handle = button.dataset.mtoProductId;
      
      const response = await fetch(`/products/${handle}.js`);
      const secondProduct = await response.json();

      // Assume size is the last option
      const sizeOption = variantOptions[variantOptions.length - 1];

      // Find matching variant with the same size
      let matchingVariant = secondProduct.variants.find(
        (variant) => variant.options[variantOptions.length - 1] === sizeOption
      );

      // Update button state
      if (matchingVariant) {
        button.dataset.mtoVariantId = matchingVariant.id;
        const isAvailable = matchingVariant.available;

        button.disabled = !isAvailable;

        const textSpan = button.querySelector(".btn__text");
        if (textSpan) {
          if (isAvailable) {
            const mtoText = button.dataset.textAddToCart || "Add Made-to-Order";
            // Extract base text if it contains price (split by ·)
            const baseText = mtoText.split(" · ")[0];
            // Format price using Shopify's money format
            const formattedPrice = window.theme && window.theme.formatMoney 
              ? window.theme.formatMoney(matchingVariant.price, window.theme.moneyFormat || "${{amount}}")
              : `$${(matchingVariant.price / 100).toFixed(2)}`;
            const translatedText = baseText.concat(" · ", formattedPrice);
            textSpan.textContent = translatedText;
          } else {
            // Use sold out text from data attribute or fallback
            const soldOutText = button.dataset.textSoldOut || "Sold Out";
            textSpan.textContent = soldOutText;
          }
        }

        // Update dispatch text based on variant availability
        updateDispatchText(button, isAvailable);
      } else {
        button.disabled = true;
        const textSpan = button.querySelector(".btn__text");
        if (textSpan) {
          textSpan.textContent = button.dataset.textSoldOut || "Sold Out";
        }

        // Update dispatch text to show "Sold Out" when no matching variant
        updateDispatchText(button, false);
      }
    } catch (error) {
      button.disabled = true;
    }
  }
});